import { jsx as a } from "react/jsx-runtime";
import { cn as i } from "../../lib/utils.js";
import { Loader2Icon as n } from "lucide-react";
function s({ className: r, ...o }) {
  return /* @__PURE__ */ a(n, { role: "status", "aria-label": "Loading", className: i("size-4 animate-spin", r), ...o });
}
export {
  s as Spinner
};
//# sourceMappingURL=spinner.js.map
